import StationTypes from './StationTypes';

const StationTypesRoutes = {
  path: 'stationtypes',
  name: 'devices.devices_sensors',
  component: StationTypes,
  meta: {
    prefix_permission: 'devices_stationtypes',
  },
};

export default StationTypesRoutes;
